import swapLang from "./swapLang.js";
import { helpers } from 'vuelidate/lib/validators'

export const swapBarcode = barcode => {
    let swap = barcode.split('')
    let scanBarcode = '';
    swap.forEach(value =>{
      if(swapLang[value]){
        scanBarcode += swapLang[value]
      }else{
        scanBarcode += value
      }
    });
    return scanBarcode;
}

export const checkCodAmount = (value) => !helpers.req(value) || !( value < 100 || value > 50000 )


export const checkPersonID = personID => {
	if( personID.length != 13 ) return false;
	let sum = 0;

	for( let i = 0 ; i < 12; i++ ){
		sum += parseFloat( personID.charAt(i) ) * (13-i);
	}
	let chkbit = parseFloat( personID.charAt( 12 ) );

	let mod = sum % 11;
	let sub = 11 - mod;
	let check_digit = sub % 10;
	if ( check_digit != chkbit ) {
		return false;
	}
    
	return true;
}

export const typeParcel = type => {
    switch ( String(type) ) {
		case 'ship':
        return { name: 'พัสดุ' }
		case 'item':
        return { name: 'สินค้า' }
		case 'service':
        return { name: 'บริการ' }
        default:
        return { name: '' }
	}
}

export const printReceipt = (html , time = 100)=> {

	const win = window.open("");
	if( !win ){
		const errorMsg = 'ระบบพิมพ์อัตโนมัติไม่สามาถใช้งานได้ กรุณากดอนุญาต Pop-ups เพื่อพิมพ์ใบปะหน้า'
		alert(errorMsg)
		return errorMsg
	}
	win.document.write(html);
	setTimeout(() => {
		win.document.close();
		win.focus();
		win.print();
		win.close();
	}, time);
}

export const resetPage = () => {
	location.reload();
}